export default __webpack_public_path__ + "static/media/399.a711d7e5.jpg";